import {
	Container,
	Service,
	TrackingEventNames,
	TrackingService,
} from '../../../../symphony';

import { questionsFilerTrackingType } from '../../global-constants';
import { ITrackActionData } from '../../global-interface';

@Service()
export class SlTrackingService {
	private trackingService = Container.take('global', TrackingService);

	public onDiscussPageMount = ({
		pageAlias,
		postId,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.discussPageView,
			eventParams: {
				pageAlias,
				postId,
			},
		});
	};

	public onNewQuestionMount = (): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.discussPageView,
			eventParams: {
				postId: '0',
				pageAlias: 'ASK A QUESTION',
			},
		});
	};

	public onEditQuestionMount = ({ questionId }: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.discussPageView,
			eventParams: {
				postId: questionId,
				pageAlias: 'EDIT A QUESTION',
			},
		});
	};

	public onPostQuestionModalMount = (): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.discussPageView,
			eventParams: {
				postId: '0',
				pageAlias: 'QUESTION SUCCESSFULLY POSTED',
			},
		});
	};

	public onPostClick = ({
		pageAlias,
		postId,
		source,
		clickPostId,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onDiscussPostClick,
			eventParams: {
				postId,
				pageAlias,
				source,
				clickPostId,
			},
		});
	};

	public onTagClick = ({
		clickPostId,
		tagAlias,
		pageAlias,
		postId,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onDiscussTagClick,
			eventParams: {
				pageAlias,
				tagAlias,
				postId,
				clickPostId,
			},
		});
	};

	public onSearchClick = ({
		pageAlias,
		postId,
		searchText,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onDiscussSearchClick,
			eventParams: {
				pageAlias,
				postId,
				searchText,
			},
		});
	};

	public onCTAClick = ({
		pageAlias,
		postId,
		ctaType,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onDiscussCTAClick,
			eventParams: {
				pageAlias,
				postId,
				ctaType,
			},
		});
	};

	public onPaginationClick = ({
		pageAlias,
		postId,
		ctaType,
		pageNumber,
		clickPageNumber,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onDiscussPaginationClick,
			eventParams: {
				pageAlias,
				postId,
				ctaType,
				pageNumber,
				clickPageNumber,
			},
		});
	};

	public questionFilterChange = ({
		pageAlias,
		postId,
		sectionName,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onDiscussHomeSectionClick,
			eventParams: {
				pageAlias,
				postId,
				sectionName:
                    questionsFilerTrackingType[sectionName] || sectionName,
			},
		});
	};

	public onCourseClick = ({
		pageAlias,
		materialId,
		ctaType,
		experienceAlias,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onCourseClick,
			eventParams: {
				pageAlias,
				materialId,
				ctaType,
				experienceAlias,
			},
		});
	};

	public onJumpLinkClick = ({
		pageAlias,
		postId,
		linkClickSource,
		hyperText,
		hyperLink,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.onDiscussJumpLinkClick,
			eventParams: {
				pageAlias,
				postId,
				linkClickSource,
				hyperText,
				hyperLink,
			},
		});
	};
}
